import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'

export default ({ show, onClose, details }) => {
    if (show !== true) {
        return undefined
    }

    const r = details?.inputs?.reduce((a,c) => {
        if (a[c?.nodeId]  === undefined){
            a[c?.nodeId] = {}
        }
        a[c?.nodeId][c?.id] = `<${c?.type}>`
        return a
    }, {})

    console.log(r)
    
    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={onClose} title="Example Version">
                    <div className={styles.textAreaContainer}>
                        <div style={{ marginTop: 20}}>
                            <ul>
                            {
                                details?.inputs?.map(x => (
                                    <li>{x?.id}: {x.name}</li>
                                ))
                            }
                            </ul>
                        </div>
                        <textarea style={{ boxSizing: 'border-box', width: '100%', height: '120px'}} value={JSON.stringify(r)} />                        
                    </div>                    
                    <div className={styles.actionGroup}>                        
                        <Button style={{ width: '100%' }} variant="error" onClick={onClose}>OK</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}